import { IDmDoiTuongMienGiam } from "../../../model/respone/mien-giam/IDmDoiTuongMienGiam";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHinhThucActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmDoiTuongMienGiam[],
  LOAD_ERRR: "",

  SELECTED_START: {} as IDmDoiTuongMienGiam,

  SAVE_START: {} as IDmDoiTuongMienGiam,
  SAVE_SUCCESS: {} as IDmDoiTuongMienGiam,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IDmDoiTuongMienGiam,
  CLOSE_EDIT_MODAL: undefined,
};
export const eHinhThucActionIds = generateActionTypeIds(
  eHinhThucActionsObj,
  "HINH_THUC_MIEN_GIAM"
);
export type IHinhThucActionTypes = IGenericActionType<
  typeof eHinhThucActionsObj,
  "HINH_THUC_MIEN_GIAM"
>;
